import React from 'react';

import { IconProps } from '../../DefaultIcon';

export function ParishesIcon({ className }: IconProps) {
  return (
    <svg
      width="101"
      height="101"
      viewBox="0 0 101 101"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_2360)">
        <path
          d="M94.3564 86.0662L24.8693 100.817C20.3283 101.792 15.8787 98.8969 14.9339 94.3559L0.183151 24.8993C-0.792106 20.3583 2.10319 15.9087 6.64423 14.9639L76.1312 0.182662C80.6723 -0.792594 85.1219 2.1027 86.0667 6.64374L100.817 76.1308C101.793 80.6718 98.8974 85.1214 94.3564 86.0662Z"
          fill="#E8ECF7"
        />
        <path
          d="M50.9272 55.8331L44.2528 62.4161C43.7347 62.9342 43.7347 63.7571 44.2528 64.2752L55.4378 75.7954C55.9559 76.3135 56.7788 76.3135 57.2969 75.7954L63.8799 69.3344C64.398 68.8467 64.398 68.0239 63.9103 67.5058L52.8168 55.8636C52.3292 55.3455 51.4758 55.315 50.9577 55.8331"
          fill="#00C4B3"
        />
        <path
          d="M16.5191 84.6032C16.1534 84.6032 15.8181 84.4508 15.5439 84.207C15.0257 83.6584 15.0257 82.8051 15.5439 82.2565L74.3335 24.4421C74.8821 23.8935 75.7355 23.924 76.284 24.4421C76.8022 24.9907 76.8022 25.844 76.284 26.3926L17.4944 84.2375C17.2201 84.5118 16.8848 84.6337 16.5191 84.6337"
          fill="#00416B"
        />
        <path
          d="M46.5689 94.1427C46.2032 94.1427 45.8679 93.9903 45.5937 93.7465C45.0756 93.1979 45.0756 92.3446 45.5937 91.796L90.1202 47.9704C90.6688 47.4218 91.5221 47.4523 92.0707 47.9704C92.6193 48.519 92.5888 49.4028 92.0707 49.9209L47.5442 93.7465C47.2699 94.0208 46.9346 94.1427 46.5689 94.1427Z"
          fill="#00416B"
        />
        <path
          d="M8.56403 49.5552C8.19831 49.5552 7.86306 49.4333 7.58877 49.159C7.07067 48.6104 7.07067 47.7266 7.58877 47.2085L32.5492 22.6442C33.0978 22.0956 33.9512 22.1261 34.4998 22.6442C35.0483 23.1928 35.0179 24.0462 34.4998 24.5947L9.53929 49.159C9.265 49.4333 8.92975 49.5552 8.56403 49.5552Z"
          fill="#00416B"
        />
        <path
          d="M62.4469 90.6375C62.0812 90.6375 61.746 90.5156 61.4717 90.2413L3.90107 31.7564C3.35248 31.2078 3.38296 30.3544 3.90107 29.8059C4.44965 29.2573 5.303 29.2877 5.85158 29.8059L63.3917 88.2908C63.9098 88.8393 63.9098 89.6927 63.3917 90.2413C63.1174 90.5156 62.7822 90.6375 62.4165 90.6375"
          fill="#00416B"
        />
        <path
          d="M40.4434 95.6664C40.0777 95.6664 39.7425 95.5445 39.4682 95.2702L11.5819 66.9268C11.0638 66.3782 11.0638 65.4944 11.5819 64.9763C12.1305 64.4277 12.9839 64.4582 13.5325 64.9763L41.4187 93.2892C41.9368 93.8378 41.9368 94.6911 41.4187 95.2397C41.1444 95.514 40.8092 95.6359 40.4434 95.6359"
          fill="#00416B"
        />
        <path
          d="M86.1583 85.6397C85.7926 85.6397 85.4268 85.4873 85.1526 85.213L29.9591 27.2157C29.441 26.6672 29.4715 25.7833 30.0201 25.2652C30.5687 24.7471 31.4525 24.7471 31.9706 25.2957L87.164 83.293C87.6821 83.8416 87.6516 84.7254 87.1031 85.2435C86.8288 85.4873 86.4935 85.6092 86.1583 85.6092"
          fill="#00416B"
        />
        <path
          d="M93.7165 63.6352C93.3508 63.6352 92.9851 63.4828 92.7108 63.2085L44.1613 12.1904C43.6432 11.6418 43.6737 10.758 44.2222 10.2399C44.7708 9.72178 45.6546 9.75226 46.1727 10.2704L94.7222 61.2885C95.2403 61.8371 95.2099 62.7209 94.6613 63.239C94.387 63.5133 94.0517 63.6352 93.7165 63.6352Z"
          fill="#00416B"
        />
        <path
          d="M72.5958 12.4648C62.3556 2.22462 45.7153 2.22462 35.4751 12.4648C25.2349 22.705 25.2349 39.3453 35.4751 49.5855L52.1459 66.2563C53.1821 67.2925 54.8888 67.2925 55.925 66.2563L72.5958 49.5855C82.836 39.3453 82.836 22.705 72.5958 12.4648Z"
          fill="#00416B"
        />
        <path
          d="M69.3657 30.1108C69.3352 26.0879 67.7504 22.2783 64.8856 19.444C61.9903 16.5487 58.1502 14.9639 54.0359 14.9639C49.9215 14.9639 46.0814 16.5487 43.1861 19.444C40.2908 22.3392 38.7061 26.1793 38.7061 30.2937C38.7061 34.408 40.2908 38.2481 43.1861 41.1434C46.0205 43.9777 49.7386 45.5625 53.7311 45.6235H54.0359C58.1198 45.6235 61.9903 44.0387 64.8856 41.1434L65.4037 40.6253L63.057 38.2786L62.5389 38.7967C60.2836 41.052 57.2664 42.3015 54.0663 42.3015C50.8663 42.3015 47.8491 41.052 45.5633 38.7967C43.308 36.5414 42.0585 33.5242 42.0585 30.3242C42.0585 27.1241 43.308 24.1069 45.5633 21.8516C47.8186 19.5963 50.8358 18.3468 54.0663 18.3468C57.2969 18.3468 60.2836 19.5963 62.5389 21.8516C64.398 23.7107 65.5866 26.0879 65.9218 28.6784H63.4227C63.0875 26.7584 62.1732 25.0212 60.7712 23.6193C58.9731 21.8211 56.5654 20.8459 54.0359 20.8459C51.5063 20.8459 49.0986 21.8516 47.3005 23.6193C45.5024 25.4174 44.4966 27.7946 44.4966 30.3546C44.4966 32.9147 45.5024 35.2919 47.3005 37.09C49.0682 38.8577 51.3844 39.8329 53.8835 39.8634H54.0359C56.5654 39.8634 58.9731 38.8577 60.7712 37.0595L61.2893 36.5414L58.9426 34.1947L58.4245 34.7128C57.2664 35.8709 55.7121 36.5109 54.0359 36.5109C52.3596 36.5109 50.8358 35.8709 49.6472 34.7128C48.8853 33.9509 48.3367 33.0061 48.0624 32.0004H69.3657V30.2022M54.0359 28.7089H48.0624C48.3367 27.7032 48.8853 26.7584 49.6472 25.9965C50.8053 24.8383 52.3596 24.1679 54.0359 24.1679C55.7121 24.1679 57.2359 24.8079 58.4245 25.9965C59.1864 26.7584 59.735 27.7032 60.0093 28.7089H54.0359Z"
          fill="#E8ECF7"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_2360">
          <rect width="101" height="101" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
